import styled from "@emotion/styled";

export const Container = styled.div`
	max-width: 1240px;
	width: 100%;
	margin: 0 auto;
	padding: 20px;
	position: relative;
	min-height: 100%;
`;

export const LandingContainer = styled.div`
	padding: 68px 20px 150px 20px;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: center;
	background: url("${({theme}) => theme.background.authBackground}") center;
	background-size: cover;
	margin: 0 auto;
	width: 100%;
	color: #ffffff;
	position: relative;

	&.full-screen {
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
	}

	> svg {
		height: 60px;
		width: auto;
		margin-bottom: 28px;
	}

	h1 {
		font-style: normal;
		font-weight: 700;
		font-size: 20px;
		line-height: 118%;
		text-align: center;
		letter-spacing: 0.01em;
		text-transform: uppercase;
		margin-bottom: 28px;
	}

	a.close {
		position: absolute;
		top: 20px;
		right: 20px;
		width: 24px;
		height: 24px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	@media (min-width: 769px) {
		.logoFR {
			width: 230px;
			height: 280px;
		}

		.logoEN {
			width: 230px;
			height: 260px;
		}
	}

	@media (max-width: 768px) {
		.logoEN,
		.logoFR {
			width: 138px;
			height: auto;
		}
	}
`;

export const ContainerWithSidebar = styled.div`
	display: flex;
	flex-direction: column;
	max-width: 1240px;
	width: 100%;
	margin: 0 auto;
	gap: 20px;
	text-align: left;

	@media (min-width: 769px) {
		padding: 40px 20px;
		flex-direction: row;
		flex-grow: 1;
	}
`;

export const InnerContainer = styled.div`
	display: flex;
	flex-direction: column;
	flex-grow: 1;

	@media (min-width: 769px) {
		gap: 20px;
	}
`;

export const AsideContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
	width: 100%;
	padding: 0 20px;

	@media (min-width: 769px) {
		max-width: 384px;
	}
`;
